// extracted by mini-css-extract-plugin
export default {"HomePage":"VideoBlogPage-module--HomePage--PZ8Fg"};